module.exports = __webpack_public_path__ + "static/media/1.2ee0ab48.jpg";